import { BoardVisibility } from '@/api/common';
import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SetBoardVisibilityParams } from '../../../api/commands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetWorkspaceVisibleSetting extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetWorkspaceVisibleSetting';

    public constructor(public isWorkspaceVisible: boolean) {
        super(SetWorkspaceVisibleSetting.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetWorkspaceVisibleSetting): Promise<boolean> => {
    const visibility = action.isWorkspaceVisible ? BoardVisibility.WorkspaceVisible : BoardVisibility.Private;
    return await useSendCommand(action, {
        createCommand: () =>
            new SetBoardVisibilityParams(state.id, visibility, action.isWorkspaceVisible ? state.canWorkspaceMembersComment : false),
    });
};

const reducer = (state: StorymapState, action: SetWorkspaceVisibleSetting): void => {
    state.isWorkspaceVisible = action.isWorkspaceVisible;
    if (!action.isWorkspaceVisible) {
        state.canWorkspaceMembersComment = false;
    }
};

//@ts-ignore
registerMiddleware(SetWorkspaceVisibleSetting.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetWorkspaceVisibleSetting.ACTION_TYPE, reducer);
